module.exports = __webpack_public_path__ + "img/loseblatt3.8a33232e.jpg";